import { render, staticRenderFns } from "./borrow.html?vue&type=template&id=00548974&scoped=true&"
import script from "./borrow.js?vue&type=script&lang=js&"
export * from "./borrow.js?vue&type=script&lang=js&"
import style0 from "./borrow.sass?vue&type=style&index=0&id=00548974&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00548974",
  null
  
)

component.options.__file = "borrow.vue"
export default component.exports